import { getProp } from '@sh24/contentful-service/utils'
import { formatPrice } from '../utils/helpers'
import { calculateMultiProductDiscount } from '../order-journeys/_v2/calculators'

export const loadOptions = (ctx) => {
  const { locale, currency, product } = ctx
  if (!product) return []
  const singleOption = product?.options?.filter((option) => option.inStock === true).length === 1
  return product?.options?.map((option) => {
    const price = option.price[currency]
    const formattedPrice = formatPrice({ price, locale, currency })
    const checked = option.inStock && (!!option.defaultChecked || singleOption || !!product.isBundle)
    return {
      ...option,
      id: option.identifier,
      value: option.identifier,
      label: `${option.label} ${formattedPrice}`,
      hint: option.hint,
      checked,
      price,
    }
  })
}

export const handleSetSelectedPrice = (ctx) => {
  const { options } = ctx
  return options.filter((option) => option.checked).reduce((acc, option) => acc + option.price, 0)
}

const handleRadios = (ctx, event) =>
  ctx.options.map((option) => {
    if (option.value === event.payload) {
      return {
        ...option,
        checked: true,
      }
    }
    return { ...option, checked: false }
  })

const handleCheckboxes = (ctx, event) =>
  ctx.options.map((option) => {
    if (option.value === event.payload) {
      return {
        ...option,
        checked: !option.checked,
      }
    }
    return option
  })

const filterEmptyParams = (obj) => {
  const filtered = Object.entries(obj).filter(([_, value]) => value && value.length > 0)
  return Object.fromEntries(filtered)
}

const getSelectedProducts = (context) => {
  const options = getProp(context, 'options') || []
  return options.filter((option) => option.checked && option.id)
}

const getSelectedProductIds = (context) => {
  const selected = getSelectedProducts(context)
  return selected.map((option) => option.id)
}

const getOrderParams = (context) =>
  filterEmptyParams({
    productId: getProp(context?.product, 'identifier'),
    selected: getSelectedProductIds(context),
    referrer: getProp(context, 'referrer'),
  })

export const buildOrderJourneyUrl = (context) => {
  const baseUrl = getProp(context?.orderJourney, 'url')
  const query = new URLSearchParams(getOrderParams(context)).toString()
  return query ? `${baseUrl}?${query}` : baseUrl
}

export const handleSetOptions = (ctx, event) =>
  ctx.checkboxes ? handleCheckboxes(ctx, event) : handleRadios(ctx, event)

export const handleDiscount = (ctx) => {
  const selected = getSelectedProducts(ctx)
  return calculateMultiProductDiscount({
    basket: selected,
    discountSettings: ctx.discountSettings,
  })
}
